module.exports = new __parcel__URL__("Brickfilms.531c8ae9.jpeg").toString();